import {inject, Injectable, NgZone} from '@angular/core';
import {DataUpdateService} from "./data-update.service";
import {PwaService} from "./pwa.service";
import {isNative} from "../utils";
import {CapacitorUpdater, NoNeedEvent} from "@capgo/capacitor-updater";
import {App} from "@capacitor/app";

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  private readonly dataUpdateService = inject(DataUpdateService);
  private readonly ngZone = inject(NgZone);
  private readonly pwaService = inject(PwaService);

  public initialize() {
    if(!isNative) {
        App.addListener('resume', () => {
          this.ngZone.run(() => this.update())
        });
    } else {
      CapacitorUpdater.addListener(
        'noNeedUpdate',
        (e: NoNeedEvent) => {
          this.update();
        }
      );
    }
      this.update();
  }

  private async update() {
    if (!isNative) {
      await this.pwaService.checkForUpdates();
    }
    await this.dataUpdateService.updateData();
  }
}
